 setTimeout(function(){
   /*For Mega Menu*/
$('.submenus-inner .list-menu').masonry({
  itemSelector: '.nav-item',
  columnWidth: '.nav-item',
  percentPosition: true
});
/*For Mega Menu End*/
},2000);
$(document).ready(function(){
/*Mobile Menu*/
$('.hamburger').click(function(){
	$('html').toggleClass('opennav');
});

$('.header-scn-main .menu-main .header__inline-menu ul>li:first').addClass('subnav');
$('.header-scn-main .menu-main .header__inline-menu ul>li').click(function(){
	$('.header-scn-main .menu-main .header__inline-menu ul>li').removeClass('subnav');
	$(this).addClass('subnav');
});
	/*On Scroll Fixed*/
	$(window).on('scroll', function(){
		if($(window).scrollTop() > 20){
			$('body').addClass('body-fixed');
		}else{
		 	$('body').removeClass('body-fixed');
		}
	})  
	$(window).trigger('scroll')
	/*On Scroll Fixed*/
	/**Menu Code**/
	
$(".header-scn-main .menu-main ul li").hover(
  function () {
  	$(this).addClass("lihover");
  }, 
  function () {
  	$(this).removeClass("lihover");
  }
);
 $(".header-scn-main .menu-main .mobile-nav ul li.subnav .accordion").click(function(){
  $(this).toggleClass("subnav-open");  
  $('html').toggleClass("mob-bottom-open");   
});
/**Footer Mobile Accordion Start**/
if (window.matchMedia("(max-width: 992px)").matches) {
  $('.footer__content-top .footer-block--menu').click(function(){
    $(this).siblings().removeClass('ftr-opennav').find('.footer-block__details-content.list-unstyled').slideUp();
    $(this).toggleClass('ftr-opennav').find('.footer-block__details-content.list-unstyled').slideToggle();
  }) 
  $('.playlist-title-mobile').click(function(){
    $('.ftr-playlist').slideToggle();
  });
}
/**Footer Mobile Accordion End**/
});

function searchModelOpen(){
	document.getElementById('search_modal').classList.add("openmodel");
}

function searchModelClose(){
	document.getElementById('search_modal').classList.remove("openmodel");
}


/**PLP and Searchpage start**/

setTimeout(function(){
 $(document).ready(function(){
	$('.facet-filters__sort').after('<div class="selectbox-group"><span class="selectlabel"></span><ul class="selectbox"></ul></div>');
		$('.facet-filters__sort option').each(function(){
		 	var option = $(this).text()
		 	var selectvalue = $(this).val();
		 	$('ul.selectbox').append(`<li class="item" data-val="${selectvalue}">${option}</li>`)
		  	})
		$('.selectbox-group .selectlabel').text($(".facet-filters__sort").find(":selected").text());
		$('.selectbox li:first').addClass('active')
		$(document).on('click','.selectbox li', function(){
			const thistxt = $(this).text()
			const selectvalue = $(this).data('val');
            const slicevalue = selectvalue.split(':');
            const triggerSortUrl = '#/sort:'+slicevalue[slicevalue.length-3] +':'+slicevalue[slicevalue.length-2];
            window.location.hash = triggerSortUrl;
           $('.selectbox-group .selectlabel').text(thistxt)
			$('.selectbox li').removeClass('active')
			$(this).addClass('active')
			$('.selectbox').slideUp();
			$('.selectlabel').removeClass('select-open');
		});
		$(document).on('click','.selectbox-group .selectlabel', function(){
			$('.selectbox').slideToggle();
			$(this).toggleClass('select-open');
		})
});


  var setClass = localStorage["classStprage"];
    if (setClass) {
       $('.viewtoptions .view-item:nth-child(1)').attr('data-class', 'pdpgrid3')
      $('.viewtoptions .view-item:nth-child(2)').attr('data-class', 'pdpgrid4')
        $("#pdpgridmodes").addClass(setClass);
    }
    $(document).on("click", '.viewtoptions .view-item', function() {
      console.log($(this).attr('data-class'));
       $("#pdpgridmodes").attr("class", $(this).data('class'));        
        localStorage.setItem('classStprage', $(this).data('class'));        
        return false;
    });

  
  },2500);
setTimeout(function () {
  // Wrap the facets heading + dropdown
  $("#facets__wrapper .facets__heading, #facets__wrapper .ss__dropdown")
    .wrapAll("<div class='facets-wrapper-group' />");

  // Add the filter toggle (accessible as a button)
  $('.ss__theme div#facets__wrapper').append(
    '<div class="pdtfiltertoggle" role="button" tabindex="0" aria-expanded="false">' +
      '<span class="filter-text">Filters</span> ' +
      '<span class="filter-icon"></span>' +
    '</div>'
  );

  // Click handler
  $(document).on('click', ".pdtfiltertoggle", function () {
    var $this = $(this);
    $this.toggleClass('pdtfiltertoggle-open');

    if ($this.hasClass('pdtfiltertoggle-open')) {
      $this.find('.filter-text').text('Close');
      $this.attr('aria-expanded', 'true');
    } else {
      $this.find('.filter-text').text('Filters');
      $this.attr('aria-expanded', 'false');
    }

    $('.facets-wrapper-group').toggleClass('facets-wrap-show');
  });

  // Keyboard accessibility (Enter or Space = click)
  $(document).on('keydown', ".pdtfiltertoggle", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $(this).trigger("click");
    }
  });

}, 3000);
/**PLP and Searchpage end**/

/** PDP: Move Inventory Modal **/
setTimeout(function(){
  if($('.view-store-avail').length) {
    var modalBlock = jQuery('#inventoryModal');
    var modalBlockOverlay = jQuery('#inventoryOverlay');
    modalBlockOverlay.appendTo('.view-store-avail');  
    modalBlock.appendTo('.view-store-avail');
  }
},3000);
/** PDP: Move Inventory Modal end **/

/* White background on hover menu */
$(document).ready(function () {
  $(".header-menu > .navitem").hover(
    function () {
      $('body').addClass("activeMenu"); },
    function () { $('body').removeClass("activeMenu");}
  );
});
/* White background on hover menu end */

/* Add Class For Empty Submenus */
setTimeout(function () {
  $('.hdr-submenus').each(function () {
    
    var colItem = $(this).find('.menu-col').length;
    var hasImageBlock = $(this).find('.cate-img-part-wrapper').length;

    if (colItem === 0 && hasImageBlock === 0) {
      $(this).parent().addClass('noSubmenu');
    }

  });
}, 2000);
$(document).ready(function () {
  $('.category-col-group').each(function () {
    
    const hasContent = $(this).children().length > 0;
    const hasText = $.trim($(this).text()).length > 0;

    if (!hasContent && !hasText) {
      $(this).addClass('hidden');
    }

  });
});
/* Add Class For Empty Submenus end */
